// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("bs-platform/lib/js/caml_option.js");

function makeProps(searchTypes, value, onBlurOpt, onChange, disabledOpt) {
  var onBlur = onBlurOpt !== undefined ? onBlurOpt : (function (prim) {
        
      });
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var partial_arg = {
    value: value,
    onBlur: onBlur,
    onChange: onChange,
    disabled: disabled
  };
  var partial_arg$1 = {
    types: searchTypes
  };
  return function (param, param$1, param$2) {
    var tmp = {
      searchOptions: partial_arg$1,
      inputProps: partial_arg,
      children: param
    };
    if (param$1 !== undefined) {
      tmp.key = Caml_option.valFromOption(param$1);
    }
    return tmp;
  };
}

exports.makeProps = makeProps;
/* No side effect */
